import { useEffect, useState } from 'react'
import { tiempoConcluido } from '@domino/core'

/**
 * El reloj de la ronda, en los torneos sin organizador que juegan con tiempo.
 *
 * Cuenta hacia atrás contra `venceEn`, que manda el API. El teléfono solo
 * muestra: quien cierra las mesas al llegar a cero es el servidor, y lo que
 * cambia (la mesa cargada, la ronda siguiente) llega por los avisos del torneo
 * como cualquier otro resultado.
 */

/** Con menos de esto el reloj se pinta de alerta. */
const APURADO_MS = 5 * 60_000

function mmss(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000))
  const minutos = Math.floor(total / 60)
  const segundos = total % 60
  return `${minutos}:${String(segundos).padStart(2, '0')}`
}

export function RelojDeRonda({ venceEn, ronda }: { venceEn: string; ronda: number }) {
  const [ahora, setAhora] = useState(() => Date.now())
  const concluido = tiempoConcluido(venceEn, ahora)

  /* Un tic por segundo mientras corre. Al llegar a cero se detiene: lo que
     queda en pantalla ya no cambia con la hora. */
  useEffect(() => {
    if (concluido) return
    const tic = window.setInterval(() => setAhora(Date.now()), 1000)
    return () => window.clearInterval(tic)
  }, [concluido])

  if (concluido) {
    return (
      <div className="reloj-ronda concluido" role="alert">
        <strong>Tiempo concluido</strong>
        <span>
          Se acabó el tiempo de la ronda {ronda}. Terminen la mano que están jugando y anótenla:
          es la última, y con ella se cierra la mesa. Si quedan empatados, se sigue jugando hasta
          que uno quede arriba. Después se arma la ronda siguiente.
        </span>
      </div>
    )
  }

  const queda = new Date(venceEn).getTime() - ahora
  return (
    <div className={`reloj-ronda ${queda <= APURADO_MS ? 'apurado' : ''}`} role="timer">
      <span>Tiempo de la ronda {ronda}</span>
      <strong>{mmss(queda)}</strong>
    </div>
  )
}
